import { cn } from '@/lib/utils';
import { t } from '../i18n';

interface SpinnerProps {
  /** Отдельный блок по центру — для состояния загрузки экрана. */
  block?: boolean;
  /** Мелкий — внутри кнопки или строки. */
  small?: boolean;
  className?: string;
}

export function Spinner({ block = false, small = false, className }: SpinnerProps): JSX.Element {
  const circle = (
    <span
      className={cn(
        'inline-block animate-spin rounded-full border-current/20 border-t-current align-middle',
        small ? 'size-4 border-2' : 'size-6 border-[2.5px] text-accent',
        className,
      )}
      role="status"
      aria-label={t('components.loading')}
    />
  );
  return block ? <div className="flex justify-center p-10">{circle}</div> : circle;
}
